import styled from 'styled-components'
import React, { useContext, useState } from 'react'
import Select from 'react-select'
import { Input } from '@futures-platform/ui'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import styles from '../../styles.module.css'

const ActorsItem = ({ dp, id, deleteClick }) => {
  const {
    dispatch,
    state: { actors },
  } = useContext(DataContext)

  // const [year, setYear] = useState(dp.year)
  // const [description, setDescription] = useState(dp.description)

  const stripAllHtml = (html) => {
    if (!html) return '';
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const modifiedText = stripAllHtml(pastedText);
    document.execCommand('insertText', false, modifiedText);
  };

  return (
    <div
      className="d-flex w-100"
      style={{
        position: 'relative',
        marginBottom: '12px',
      }}>
      <textarea
        type="text"
        name="yearDescription"
        value={dp}
        onChange={(v) => {
          const value = v.target.value
          // setDescription(() => value)
          // dp.description = v.target.value
          const temp = [...actors]
          temp[id] = value
          dispatch({
            type: ACTIONS.ACTORS,
            payload: temp,
          })
        }}
        onPaste={handlePaste}
        onBlur={(e) => {
          const temp = [...actors]
          temp[id] = stripAllHtml(temp[id])
          dispatch({
            type: ACTIONS.ACTORS,
            payload: temp,
          })
        }}
        style={{
          // marginLeft: '20px',
          minHeight: '70px',
          maxWidth: '94%',
          position: 'relative',
          resize: 'none',
        }}
      />
      <Close
        className="btn-round btn-sm af-custom-close"
        onClick={deleteClick}
      />
    </div>
  )
}

export const Actors = (props) => {
  const {
    dispatch,
    state: { actors },
  } = useContext(DataContext)

  // const [devPathRows, setdevPathRows] = React.useState(value || [])

  const addMore = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // setdevPathRows(() => [
    //   ...devPathRows,
    //   {
    //     year: 2023,
    //     description: '',
    //     isSubmited: false,
    //   },
    // ])
    dispatch({
      type: ACTIONS.ACTORS,
      payload:
        !actors?.length || (!!actors && actors?.length === 0)
          ? ['']
          : [].concat(actors, ''),
    })
  }

  const deleteClick = React.useCallback(
    (i) => {
      // setdevPathRows(() => {
      //   const devPathsTemp = [...devPathRows]
      //   devPathsTemp.splice(i, 1)
      //   return devPathsTemp
      // })
      const actorsTemp = [...actors]
      actorsTemp.splice(i, 1)
      dispatch({
        type: ACTIONS.ACTORS,
        payload: actorsTemp,
      })
      // onChange(newValues)
    },
    [actors, dispatch],
  )

  return (
    <>
      {!!actors?.length &&
        actors.map((dp, i) => (
          <ActorsItem
            dp={dp}
            key={i}
            id={i}
            deleteClick={() => deleteClick(i)}
          />
        ))}

      {/* devPathRows.map((dp, i) => DevelopmentPathItem(dp, i, options))} */}
      <AddDevPathBtn
        className="btn btn-outline-secondary"
        // disabled={disabled}
        onClick={addMore}
        type="button"
        style={{
          width: 'fit-content',
          height: 'fit-content',
          // marginLeft: '100px',
        }}>
        <Plus className="af-custom-plus" /> Add
      </AddDevPathBtn>
    </>
  )
}

const AddDevPathBtn = styled.button`
  width: 'fit-content';
  height: 'fit-content';
  color: #006998;
  border-color: #006998
  &:hover {
    color: #fff !important;
    background-color: #006998 !important;
    border-color: #006998 !important;
  }
`
const Plus = styled.span`
  // position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
`
const Close = styled.span`
  position: absolute;
  right: 0;
  top: 38%;
  cursor: pointer;
`
